<template>
    <aicc-page :pageId="this.contextPageId">
    <ur-area>
        <ur-form-box toggleable column="3">
            <ur-form-row>
                <ur-form-item :label="$t('MSG_TXT_EMAIL')" labelAlign="right"  :vertical="false" >
                    <ur-text-field :key="korKey" ref="emailtxt" v-model="userEmailValue" style="width: 300px;"  :placeholder="$t('MSG_TXT_INPUT_EMAIL')" :disabled="false" :clearable="true" :readonly="false"></ur-text-field>
                </ur-form-item>
                <ur-form-item :label="$t('MSG_TXT_LEVEL')" labelAlign="right" :vertical="false" >                
                    <ur-dropdown v-model="levelValue" style="width: 300px;" :items="dropdownItems" />
                </ur-form-item>
                <ur-form-item no-label noFlex>
                    <ur-button shape="solid"  primary @click="getUserList()"> {{$t("MSG_BTN_SRCH2")}} </ur-button>
                </ur-form-item>
            </ur-form-row>
        </ur-form-box>
        <ur-data-grid :headers="headers" :options="options" :data-source="dataSet" ref="grid" @grid:click="clickEvent" >
            <template #right-info>
                <ur-button primary large @click="openInviteModal()"><i class="new_invite_icon"/> {{$t("MSG_BTN_INVITE")}} </ur-button>
            </template>
        </ur-data-grid>
            <inviteUserPopTag ref="inviteUser" @onClose="getUserList" :saasLevelList="tmpLevelList" />
            <!-- <userDetailPopTag ref="userDetail" @onClose="getUserList" :userInfo="selectedUserInfo" :saasLevelList="saasLevelList" />
  -->
            <aicc-user-modal ref="userDetail" @onClose="getUserList" :switchFlag=changeSwitchFlag :modStatus=status 
            :userInfo="selectedUserInfo"  :saasLevelList="tmpLevelList" @changeStatus="changeStatus"/>
        </ur-area>
 
    </aicc-page>

</template>
<script>
import BasePage from '~cm/components/BasePage';
import urDataGrid from '@uidev/grid/urDataGrid/urDataGrid';
import inviteUserPop from '../../components/CMP_AIU_00001.vue';

export default {
    name: 'PGE_AIU_00001', // eslint-disable-line vue/name-property-casing
    extends: BasePage,
    components:{
        urDataGrid,
        inviteUserPopTag:inviteUserPop,
    },
    data() {
        return {
            headers : [
                {text:  this.$i18n.t('MSG_TXT_NAME'), value: 'userName', width: '200px'},
                {text:  this.$i18n.t('MSG_TXT_EMAIL'), value: 'userEmail'  },                
               {text:  this.$i18n.t('MSG_TXT_LEVEL'), value: 'levelName', width:"100px"},
                {text: this.$i18n.t('MSG_BTN_ACTV'),  value: 'userAccountStateCode', width:"100px",align:'center', customClass : function(v, r) {
                    if(v === '1') return 'check2';
                    if(v === '7') return 'nonCheck';
                    return 'nonCheck'
                }},
                {text: this.$i18n.t('MSG_TXT_USR_RGST_DT'),  value: 'firstRegistrationDTM', width:"150px",type:"date"},
                {text: '마지막 변경일',  value: 'finalModificationDTM', width:"150px", type:"date"},
                {text: ' ', value: 'pwOtp ', align:'center', freeze:true, width: '30px'
                    , customClass : function(v, r) {
                        return 'btn btn_modify'
                    }    
                    // ,component: {
                    //     props: ['row', 'value', 'text'],
                    //     template :
                    //     '<span><button type="button" class="btn btn_modify"  @click="openUserDetailModal">보기</button>\
                    //     <aicc-user-modal ref="userDetail" :userInfo="row"  :saasLevelList="saasLevelList" /></span>\
                    //     ',
                    //     computed:{
                    //         conv_modal(){
                    //             return this.$refs.userDetail;
                    //         },
                    //         saasLevelList(){
                    //             return this.getComponent('PGE_AIU_00001').saasLevelList;
                    //         },
                    //     },
                    //     mounted(){
                    //         this.getComponent('PGE_AIU_00001');
                    //     },
                    //     methods: {
                    //         openUserDetailModal() {
                    //            this.$refs['userDetail'].open();
                    //         },
                    //         getComponent(name) {
                    //             let component = null;
                    //             let thisComponent = this;
                    //             while(thisComponent && !component) {
                    //                 if(thisComponent.$options.name === name) {
                    //                     component = thisComponent;
                    //                     break;
                    //                 }
                    //                 thisComponent = thisComponent.$parent;
                    //             }
                    //             return component;
                    //         },
                    //     }
                    // }
                },
            ],        
            userInfoAsk: {
                loginId: '',
                levelId: '',
                userName:'',
            },
            selectedUserInfo:{},
            saasLevelList : [],
            tmpLevelList : [],
            saasUserInfoList : [],
            levelValue : '',
            userEmailValue:'',
            dataSet : [],
            modStatus:false,
            switchFlag:false,
            options: { 
                infinityScroll : true,
                pagination: true,
                internalPaging:true,
                /* height: 0, */
                msgTotal: "총 #",
                msgAscending   : '오름차순 정렬',
                msgDescending  : '내림차순 정렬',
                msgPerPage : '#건씩 보기',            
                msgEmptyData: '선택하신 조건의 조회결과가 없습니다.',
            },
            korKey:0,
        }
        
    },
    computed:{
        dropdownItems(){
            return this.saasLevelList;
        },
        items(){            
            return this.saasUserInfoList;
        },
        status(){
            return this.modStatus;
        },
        changeSwitchFlag(){
            return this.switchFlag;
        }
    },
    watch:{
        userEmailValue: {
            immediate: true,
            handler(newValue, oldValue) {
                const korRegex = /[ㄱ-ㅎ|ㅏ-ㅣ|가-힣]/;
                const isKor = korRegex.test(newValue)
                if(isKor === true) {
                    this.userEmailValue = oldValue;
                    this.korKey++;

                    this.$nextTick(() => {
                        this.$refs['emailtxt'].focus();
                    })
                }
            }
        }
    },
    methods:{
         clickEvent(cell,row,field, e) {
             if (typeof e === 'object') {
                if (e.button === 2) {
                return;
                }
            }
            if(row.userAccountStateCode==="1"){
                this.switchFlag = true;
            }else{
                this.switchFlag = false;
            }


            if(field.value==="pwOtp "){
                this.modStatus = true;
                this.selectedUserInfo = row;
                this.$refs['userDetail'].open();
            }else{              
                this.modStatus = false;                
                this.selectedUserInfo = row;
                this.$refs['userDetail'].open();
            }
           
        },
        getUserList(){
            this.options.msgEmptyData = '';
            this.userInfoAsk.loginId =this.userEmailValue;
            this.userInfoAsk.levelId =this.levelValue;
            http.request(this.contextPageId, 'DTS_AIU_00001', {
                    data: this.userInfoAsk,
                }).then((response) => {
                    
                    for(let index in response.data.userInfoList) {
                        response.data.userInfoList[index].firstRegistrationDTM = 
                        utils.toStringByFormat(utils.toDate(response.data.userInfoList[index].firstRegistrationDTM), 'YYYY-MM-DD');
                        response.data.userInfoList[index].finalModificationDTM = 
                        utils.toStringByFormat(utils.toDate(response.data.userInfoList[index].finalModificationDTM), 'YYYY-MM-DD');

                    }
                    this.dataSet=response.data.userInfoList;
                    this.$refs['grid'].setCurrentPage(1);
                    if(response.data.userInfoList.length===0){
                     this.options.msgEmptyData = this.$i18n.t('MSG_TXT_NO_FILTERED_DATA');
                    }
                });
        
        },
        getLevelList(){
            http.request(this.contextPageId, 'DTS_AIU_00002', {
                    data: this.userInfoAsk,
                }).then((response) => {
                    let levelList = [];
                    let notAllLevelList = [];
                    console.log(response.data);
                    for(let index in response.data.levelList) {
                        console.log(response.data.levelList[index].userGroupId);
                        if(response.data.levelList[index].userGroupId!==""){
                            notAllLevelList.push({value:response.data.levelList[index].userGroupId,text:response.data.levelList[index].userGroupName});

                        }
                        levelList.push({value:response.data.levelList[index].userGroupId,text:response.data.levelList[index].userGroupName});
                    }
                    console.log(notAllLevelList                    )
                    this.saasLevelList = levelList;
                    this.tmpLevelList = notAllLevelList;
                    this.levelValue = levelList[0].value;
                    this.move=1;
                });
        
        },
        openInviteModal() {
            this.$refs['inviteUser'].open();
        },
        changeStatus(status){
            this.modStatus = status;
        },
        /* handleResize(event) {   
            this.$nextTick(() => {
            this.options.height = $(".ur-area").css("height").replace("px","")-330;
            });
        }, */
    },
    created(){
        
    },
    beforeDestroy(){
        /* window.removeEventListener('resize', this.handleResize); */
    },
    mounted(){/* 
        console.log($(".ur-data-grid__content").css("padding-right"))
         $(".ur-data-grid__content").css({'padding-right': '100px'});
         console.log($(".ur-data-grid__content").css("padding-right")) */
        /* this.options.height = $(".ur-area").css("height").replace("px","")-330;
        window.addEventListener('resize', this.handleResize); */
        this.getUserList();
        this.getLevelList();
       
    }
}
</script> 
<style scoped>
::v-deep .ur-data-grid > .ur-data-grid__table > .ur-data-grid__content  > .ur-data-grid__content__scroll-wrapper> .ur-data-grid__content__row{
   /*  padding-right: 10px;    */    
    cursor:pointer;
}
.-page-root-container {
        height: 100%;
         overflow-y: auto;
    }
::v-deep .ur-data-grid > .ur-data-grid__table > .ur-data-grid__content  > .ur-data-grid__content__scroll-wrapper> .ur-data-grid__content__row.ur-data-grid__content--empty__row{
    font-size: 14px;
    font-weight: 400;
    line-height: 21px;
}
</style>
